/* Sleeve Stars — PDP visuals injector. */
(function () {
  'use strict';

  var GALLERY_HERO_INDEX = 0;
  var GALLERY_KEEP_COUNT = 7;

  /* ============================================================
     PER-PRODUCT CONFIG
     Keys are internal identifiers — NOT required to match the URL handle.
     PRODUCT_RULES (below) maps URL keywords → config key, so renaming a
     product URL only requires updating the rule, not the config block.

     Each entry has:
       img.benefit[]    — benefit section image filenames (3 items)
       img.benefitAlt[] — alt text for each benefit image
       img.step[]       — how-to step image filenames (3 items)
       img.stepAlt[]    — alt text for each step image
       pressTabs[]      — press carousel entries (leave [] to hide the section)
     ============================================================ */
  var PRODUCT_CONFIG = {

    'ankle-brace': {
      bestFor: [
        { icon: '01._Plantar_fasciitis_WT_AB.svg',  title: 'Plantar fasciitis',      sub: 'Heel-to-arch compression relief' },
        { icon: '02._Achilles_tendonitis_WT_AB.svg',   title: 'Achilles tendonitis',    sub: 'Overuse repair, all day' },
        { icon: '03._Fits_inside_work_boots_WT_AB.svg',     title: 'Fits inside work boots', sub: 'Slim profile fits under boots' },
        { icon: '04._Post-injury_recovery_WT_AB.svg',    title: 'Post-injury recovery',          sub: 'Support while you heal, not just while it hurts' },
        { icon: '05._Overnight_wear_WT_AB.svg',    title: 'Overnight wear',         sub: 'Gentle compression while you sleep' },
        { icon: '06._Long_shifts_on_feet_WT_AB.svg', title: 'Long shifts on feet',    sub: '12-hour compression without fatigue' }
      ],
      img: {
        benefit: [
          'Graduated_compression.png',
          'Joint_stability.png',
          'All-day_comfort.png'
        ],
        benefitAlt: ['Compression fabric', 'Worker', 'At home'],
        step: [
          '1._Slide_it_on.png',
          '2._Wrap_the_strap.png',
          '3._Wear_all_day.png'
        ],
        stepAlt: ['Slide on', 'Wrap strap', 'All day']
      },
      pressTabs: [
        {
          name: 'Healthline',
          cls: 'ss-pc__logo--healthline',
          quote: "The most comfortable compression brace we've tested — stays put through a full shift and feels like nothing under work boots.",
          image: 'Health_Line.png',
          alt: 'Healthline — Nurse wearing Sleeve Stars on shift'
        },
        {
          name: "Women's Health",
          cls: 'ss-pc__logo--womenshealth',
          quote: "Real post-workout recovery support — drains swelling fast and quiets next-day ache better than any sleeve we've used.",
          image: 'Womans_Health.png',
          alt: "Women's Health — wearing the sleeve at home"
        },
        {
          name: "Runner's World",
          cls: 'ss-pc__logo--runnersworld',
          quote: "The figure-8 strap is the game-changer — mile-after-mile knee and ankle tracking that doesn't bunch or slip.",
          image: 'Runner_s_World.png',
          alt: "Runner's World — running outdoors in the brace"
        },
        {
          name: 'Good Housekeeping',
          cls: 'ss-pc__logo--goodhousekeeping',
          quote: "Wash after wash, it holds its shape. The most durable compression sleeve in our 100-cycle test.",
          image: 'Good_housekeeping.png',
          alt: 'Good Housekeeping — Close-up of the fabric'
        },
        {
          name: 'Prevention',
          cls: 'ss-pc__logo--prevention',
          quote: "Targeted graduated compression that arthritis sufferers swear by — pain relief without the doctor's-office price tag.",
          image: 'Prevention.jpg',
          alt: 'Prevention — Wearing the sleeve on the job'
        },
        {
          name: 'SELF',
          cls: 'ss-pc__logo--self',
          quote: "Slim enough to wear under work pants and sleek enough we forgot it was on — until the swelling was just… gone.",
          image: 'Self.png',
          alt: 'SELF — Sliding the sleeve on'
        }
      ]
    },

    'elbow-brace': {
      bestFor: [
        { icon: '01._Tennis_elbow_WT_EB.svg',  title: 'Tennis elbow',            sub: 'Lateral epicondylitis relief' },
        { icon: '02._Golfer_s_elbow_WT_EB.svg',    title: "Golfer's elbow",           sub: 'Medial strain support' },
        { icon: '03._Arthritis_WT_EB.svg',   title: 'Arthritis', sub: 'Joint inflammation relief, all day' },
        { icon: '04._Tendonitis_WT_EB.svg',  title: 'Tendonitis',              sub: 'Overuse repair, all day' },
        { icon: '05._Lifting_strain_WT_EB.svg',    title: 'Lifting strain',          sub: 'Heavy-load joint security' },
        { icon: '06._Daily_wear_recovery_WT_EB.svg', title: 'Daily wear & recovery',   sub: 'Maintain support between flare-ups' }
      ],
      img: {
        benefit: [
          '1._Graduated_compression_EB.png?v=1780024421',
          '2._Joint_stability_EB.png?v=1780024421',
          '3._All-day_comfort_EB.png?v=1780024422'
        ],
        benefitAlt: ['Compression fabric', 'Worker', 'At home'],
        step: [
          'Slide_it_on_EB.png?v=1780024619',
          'Center_the_pad_EB.png?v=1780024619',
          'Wear_all_day_EB.png?v=1780024619'
        ],
        stepAlt: ['Slide on', 'Center the pad', 'All day']
      },
      pressTabs: [
        // TODO: add press tab entries (see ankle-brace above for the shape)
        {
          name: 'Healthline',
          cls: 'ss-pc__logo--healthline',
          quote: "The most comfortable compression brace we've tested — stays put through a full shift and feels like nothing under work boots.",
          image: 'Health_Line.png',
          alt: 'Healthline — Nurse wearing Sleeve Stars on shift'
        },
        {
          name: "Women's Health",
          cls: 'ss-pc__logo--womenshealth',
          quote: "Real post-workout recovery support — drains swelling fast and quiets next-day ache better than any sleeve we've used.",
          image: 'Womans_Health.png',
          alt: "Women's Health — wearing the sleeve at home"
        },
        {
          name: "Runner's World",
          cls: 'ss-pc__logo--runnersworld',
          quote: "The figure-8 strap is the game-changer — mile-after-mile knee and ankle tracking that doesn't bunch or slip.",
          image: 'Runner_s_World.png',
          alt: "Runner's World — running outdoors in the brace"
        },
        {
          name: 'Good Housekeeping',
          cls: 'ss-pc__logo--goodhousekeeping',
          quote: "Wash after wash, it holds its shape. The most durable compression sleeve in our 100-cycle test.",
          image: 'Good_housekeeping.png',
          alt: 'Good Housekeeping — Close-up of the fabric'
        },
        {
          name: 'Prevention',
          cls: 'ss-pc__logo--prevention',
          quote: "Targeted graduated compression that arthritis sufferers swear by — pain relief without the doctor's-office price tag.",
          image: 'Prevention.jpg',
          alt: 'Prevention — Wearing the sleeve on the job'
        },
        {
          name: 'SELF',
          cls: 'ss-pc__logo--self',
          quote: "Slim enough to wear under work pants and sleek enough we forgot it was on — until the swelling was just… gone.",
          image: 'Self.png',
          alt: 'SELF — Sliding the sleeve on'
        }
      ]
    },

    'patella-strap': {
      bestFor: [
        { icon: 'Runner_s_knee_WT_PS.svg',   title: "Runner's knee",           sub: 'Kneecap tracking on every stride' },
        { icon: 'Jumper_s_knee_WT_PS.svg',   title: "Jumper's knee",           sub: 'Impact cushion for every landing' },
        { icon: 'Patellar_tendonitis_WT_PS.svg', title: 'Patellar tendonitis',     sub: "Calms the jumper's tendon" },
        { icon: 'Osgood-Schlatter_kids_version__WT_PS.svg',   title: 'Osgood-Schlatter', sub: 'Growth-plate pain, kids & youth sizes available' },
        { icon: 'Anterior_knee_arthritis_WT_PS.svg',  title: 'Anterior knee arthritis', sub: 'Reduces kneecap load on achy joints' },
        { icon: 'Stair-day_relief_WT_PS.svg', title: 'Stair-day relief',        sub: 'Pain-free up and down' }
      ],
      img: {
        benefit: [
          'Graduated_compression_PS.png?v=1780026894', // TODO: benefit image 1 filename
          'Joint_stability_PS.png?v=1780026894', // TODO: benefit image 2 filename
          'All-day_comfort_PS.png?v=1780026895'  // TODO: benefit image 3 filename
        ],
        benefitAlt: ['', '', ''],
        step: [
          'Slide_it_on_PS.png?v=1780027259', // TODO: step 1 image filename
          'Center_the_pad_PS.png?v=1780027259', // TODO: step 2 image filename
          'Wear_all_day_PS.jpg?v=1780027260'  // TODO: step 3 image filename
        ],
        stepAlt: ['', '', '']
      },
      pressTabs: [
        // TODO: add press tab entries
        {
          name: 'Healthline',
          cls: 'ss-pc__logo--healthline',
          quote: "The most comfortable compression brace we've tested — stays put through a full shift and feels like nothing under work boots.",
          image: 'Health_Line.png',
          alt: 'Healthline — Nurse wearing Sleeve Stars on shift'
        },
        {
          name: "Women's Health",
          cls: 'ss-pc__logo--womenshealth',
          quote: "Real post-workout recovery support — drains swelling fast and quiets next-day ache better than any sleeve we've used.",
          image: 'Womans_Health.png',
          alt: "Women's Health — wearing the sleeve at home"
        },
        {
          name: "Runner's World",
          cls: 'ss-pc__logo--runnersworld',
          quote: "The figure-8 strap is the game-changer — mile-after-mile knee and ankle tracking that doesn't bunch or slip.",
          image: 'Runner_s_World.png',
          alt: "Runner's World — running outdoors in the brace"
        },
        {
          name: 'Good Housekeeping',
          cls: 'ss-pc__logo--goodhousekeeping',
          quote: "Wash after wash, it holds its shape. The most durable compression sleeve in our 100-cycle test.",
          image: 'Good_housekeeping.png',
          alt: 'Good Housekeeping — Close-up of the fabric'
        },
        {
          name: 'Prevention',
          cls: 'ss-pc__logo--prevention',
          quote: "Targeted graduated compression that arthritis sufferers swear by — pain relief without the doctor's-office price tag.",
          image: 'Prevention.jpg',
          alt: 'Prevention — Wearing the sleeve on the job'
        },
        {
          name: 'SELF',
          cls: 'ss-pc__logo--self',
          quote: "Slim enough to wear under work pants and sleek enough we forgot it was on — until the swelling was just… gone.",
          image: 'Self.png',
          alt: 'SELF — Sliding the sleeve on'
        }
      ]
    },

    'knee-brace': {
      bestFor: [
        { icon: '01._Osteoarthritis_WT_KB.svg',    title: 'Osteoarthritis',      sub: 'Bone-on-bone compression relief' },
        { icon: '02._Post-injury_support_WT_KB.svg',  title: 'Post-injury support', sub: 'Meniscus, ACL & ligament support' },
        { icon: '03._Meniscus_tear_WT_KB.svg', title: 'Meniscus tear',     sub: 'Stability while you heal' },
        { icon: '04._Standing_all_day_WT_KB.svg', title: 'Standing all day',    sub: 'Support through 12-hour shifts' },
        { icon: '05._Joint_instability_WT_KB.svg',    title: 'Joint instability',   sub: 'Stop that \"giving out\" feeling' },
        { icon: '06._Cold-weather_joints_WT_KB.svg',     title: 'Cold-weather joints', sub: 'Locks in warmth on cold days' }
      ],
      img: {
        benefit: [
          'Graduated_compression_KB.png?v=1780027788', // TODO: benefit image 1 filename
          'Joint_stability_KB.png?v=1780027788', // TODO: benefit image 2 filename
          'All-day_comfort_KB.jpg?v=1780027788'  // TODO: benefit image 3 filename
        ],
        benefitAlt: ['', '', ''],
        step: [
          'Slide_it_on_KB.png?v=1780027913', // TODO: step 1 image filename
          'Smooth_the_knit_KB.png?v=1780027913', // TODO: step 2 image filename
          'Wear_all_day_KB.webp?v=1780027912'  // TODO: step 3 image filename
        ],
        stepAlt: ['', '', '']
      },
      pressTabs: [
        // TODO: add press tab entries
        {
          name: 'Healthline',
          cls: 'ss-pc__logo--healthline',
          quote: "The most comfortable compression brace we've tested — stays put through a full shift and feels like nothing under work boots.",
          image: 'Health_Line.png',
          alt: 'Healthline — Nurse wearing Sleeve Stars on shift'
        },
        {
          name: "Women's Health",
          cls: 'ss-pc__logo--womenshealth',
          quote: "Real post-workout recovery support — drains swelling fast and quiets next-day ache better than any sleeve we've used.",
          image: 'Womans_Health.png',
          alt: "Women's Health — wearing the sleeve at home"
        },
        {
          name: "Runner's World",
          cls: 'ss-pc__logo--runnersworld',
          quote: "The figure-8 strap is the game-changer — mile-after-mile knee and ankle tracking that doesn't bunch or slip.",
          image: 'Runner_s_World.png',
          alt: "Runner's World — running outdoors in the brace"
        },
        {
          name: 'Good Housekeeping',
          cls: 'ss-pc__logo--goodhousekeeping',
          quote: "Wash after wash, it holds its shape. The most durable compression sleeve in our 100-cycle test.",
          image: 'Good_housekeeping.png',
          alt: 'Good Housekeeping — Close-up of the fabric'
        },
        {
          name: 'Prevention',
          cls: 'ss-pc__logo--prevention',
          quote: "Targeted graduated compression that arthritis sufferers swear by — pain relief without the doctor's-office price tag.",
          image: 'Prevention.jpg',
          alt: 'Prevention — Wearing the sleeve on the job'
        },
        {
          name: 'SELF',
          cls: 'ss-pc__logo--self',
          quote: "Slim enough to wear under work pants and sleek enough we forgot it was on — until the swelling was just… gone.",
          image: 'Self.png',
          alt: 'SELF — Sliding the sleeve on'
        }
      ]
    },

    'elbow-sleeve': {
      bestFor: [
        { icon: '01._Tennis_Golfer_s_elbow_WT_ES.svg',  title: "Tennis & golfer's elbow",          sub: 'Relief for racket & swing injuries' },
        { icon: '02._Tendonitis_WT_ES.svg',    title: "Tendonitis",         sub: 'Overuse repair, all day' },
        { icon: '03._Lifting_strain_WT_ES.svg',   title: 'Gym & lifting',        sub: 'Light support through heavy sets' },
        { icon: '04._Court_sports_WT_ES.svg',    title: 'Court sports',        sub: 'Tennis, pickle ball & basketball' },
        { icon: '05._Post-activity_recovery_WT_ES.svg', title: 'Post-activity recovery', sub: 'reduce soreness between sessions' },
        { icon: '06._Daily_wear_recovery_WT_ES.svg',  title: 'Daily wear & recovery', sub: 'Stays put through work and rest days' },
      ],
      img: {
        benefit: [
          'Graduated_compression_ES.png?v=1780028110', // TODO: benefit image 1 filename
          'Joint_stability_ES.png?v=1780028110', // TODO: benefit image 2 filename
          'Wear_all_day_ES.png?v=1780028110'  // TODO: benefit image 3 filename
        ],
        benefitAlt: ['', '', ''],
        step: [
          'Slide_it_on_ES.png?v=1780028255', // TODO: step 1 image filename
          'Smooth_the_knit_ES.png?v=1780028253', // TODO: step 2 image filename
          'Wear_all_day_Walk_ES.png'  // TODO: step 3 image filename
        ],
        stepAlt: ['', '', '']
      },
      pressTabs: [
        // TODO: add press tab entries
        {
          name: 'Healthline',
          cls: 'ss-pc__logo--healthline',
          quote: "The most comfortable compression brace we've tested — stays put through a full shift and feels like nothing under work boots.",
          image: 'Health_Line.png',
          alt: 'Healthline — Nurse wearing Sleeve Stars on shift'
        },
        {
          name: "Women's Health",
          cls: 'ss-pc__logo--womenshealth',
          quote: "Real post-workout recovery support — drains swelling fast and quiets next-day ache better than any sleeve we've used.",
          image: 'Womans_Health.png',
          alt: "Women's Health — wearing the sleeve at home"
        },
        {
          name: "Runner's World",
          cls: 'ss-pc__logo--runnersworld',
          quote: "The figure-8 strap is the game-changer — mile-after-mile knee and ankle tracking that doesn't bunch or slip.",
          image: 'Runner_s_World.png',
          alt: "Runner's World — running outdoors in the brace"
        },
        {
          name: 'Good Housekeeping',
          cls: 'ss-pc__logo--goodhousekeeping',
          quote: "Wash after wash, it holds its shape. The most durable compression sleeve in our 100-cycle test.",
          image: 'Good_housekeeping.png',
          alt: 'Good Housekeeping — Close-up of the fabric'
        },
        {
          name: 'Prevention',
          cls: 'ss-pc__logo--prevention',
          quote: "Targeted graduated compression that arthritis sufferers swear by — pain relief without the doctor's-office price tag.",
          image: 'Prevention.jpg',
          alt: 'Prevention — Wearing the sleeve on the job'
        },
        {
          name: 'SELF',
          cls: 'ss-pc__logo--self',
          quote: "Slim enough to wear under work pants and sleek enough we forgot it was on — until the swelling was just… gone.",
          image: 'Self.png',
          alt: 'SELF — Sliding the sleeve on'
        }
      ]
    }

  };

  /* ============================================================
     PRODUCT RULES — keyword matching against the URL handle.
     Checked in order; first match wins.
     Current URLs:
       /products/plantar-fasciitis-ankle-brace  → ankle-brace
       /products/elbow-brace                    → elbow-brace
       /products/patella-support-strap          → patella-strap
       /products/elbow-sleeve                   → elbow-sleeve
       /products/knee-support-brace             → knee-brace
     If the handle changes, only update the keywords here.
     ============================================================ */
  var PRODUCT_RULES = [
    { key: 'ankle-brace',   test: function (h) { return h.indexOf('ankle') !== -1 || h.indexOf('plantar') !== -1; } },
    { key: 'elbow-brace',   test: function (h) { return h.indexOf('elbow') !== -1 && h.indexOf('brace') !== -1; } },
    { key: 'elbow-sleeve',  test: function (h) { return h.indexOf('elbow') !== -1 && h.indexOf('sleeve') !== -1; } },
    { key: 'patella-strap', test: function (h) { return h.indexOf('patella') !== -1; } },
    { key: 'knee-brace',    test: function (h) { return h.indexOf('knee') !== -1; } }
  ];

  /* Resolved at init() time from the current page's product handle. */
  var cfg = null;
  var cfgKey = null;

  var COLOR_MAP = {
    'black':'#0E1218','jet black':'#0E1218','white':'#FFFFFF','ivory':'#F5EFE0','cream':'#F4ECDA',
    'beige':'#D9C7A7','tan':'#C9A87C','nude':'#D8B89A','skin':'#E0BFA0','sand':'#E8DBC1',
    'grey':'#8C8C8C','gray':'#8C8C8C','light grey':'#C7C7C7','light gray':'#C7C7C7','charcoal':'#36383D',
    'navy blue':'#1B2A4E','navy':'#1B2A4E','royal blue':'#1F47C2','light blue':'#7FB3E8','baby blue':'#A8C9E8','blue':'#2F6FE0',
    'turquoise':'#3FB8B8','teal':'#2E8C8C','neon green':'#5BC04A','green':'#3B7A4A','olive':'#6E7A3A','mint':'#A8D8C0',
    'red':'#D8252A','crimson':'#A6171C','maroon':'#6E1F22',
    'hot pink':'#E63E80','baby pink':'#F6C6D2','pink':'#F2A6BC','rose':'#D87386','coral':'#F47B5A',
    'orange':'#F08236','yellow':'#F5C84B','mustard':'#C49A2D',
    'light purple':'#B9A1D5','dark purple':'#5B358E','purple':'#7A4DAA','lavender':'#B7A6D6','lilac':'#C9A6D4',
    'mocha brown':'#7A5A3C','dark brown':'#4A2E1A','mocha':'#7A5A3C','brown':'#6B4A2B',
    'camo':'#5A6741','camouflage':'#5A6741'
  };
  function colorFor(name) {
    if (!name) return null;
    var key = String(name).trim().toLowerCase();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    var keys = Object.keys(COLOR_MAP).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) { if (key.indexOf(keys[i]) !== -1) return COLOR_MAP[keys[i]]; }
    return null;
  }

  var COLOR_TIP_MAP = {
    'black': 'Matches every gym fit.',
    'grey': 'Understated. Overtrained.', 'gray': 'Understated. Overtrained.',
    'white': 'Fresh-kicks energy.',
    'hot pink': 'PR-setting loud.',
    'baby pink': 'Soft look, serious support.',
    'light purple': 'Recovery-day calm.', 'lavender': 'Recovery-day calm.',
    'dark purple': 'Playoff-mode purple.',
    'light blue': 'Cool-down cool.', 'baby blue': 'Cool-down cool.',
    'navy blue': 'Locker-room classic.', 'navy': 'Locker-room classic.',
    'turquoise': 'Poolside-to-track energy.',
    'beige': 'Invisible under boots.',
    'mocha brown': 'Earth tones, iron will.', 'mocha': 'Earth tones, iron will.',
    'dark brown': 'Trail-tested neutral.',
    'neon green': 'Impossible to miss.'
  };
  function tipFor(name) {
    if (!name) return null;
    var key = String(name).trim().toLowerCase();
    if (COLOR_TIP_MAP[key]) return COLOR_TIP_MAP[key];
    var keys = Object.keys(COLOR_TIP_MAP).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) { if (key.indexOf(keys[i]) !== -1) return COLOR_TIP_MAP[keys[i]]; }
    return null;
  }
  function isDark(hex) {
    if (!hex || hex[0] !== '#') return false;
    var h = hex.length === 4 ? hex.slice(1).split('').map(function (c) { return c + c; }).join('') : hex.slice(1);
    var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    return ((0.299 * r + 0.587 * g + 0.114 * b) / 255) < 0.55;
  }
  function lightenHex(hex, amount) {
    if (!hex || hex[0] !== '#') return null;
    var h = hex.length === 4 ? hex.slice(1).split('').map(function (c) { return c + c; }).join('') : hex.slice(1);
    var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    var mix = function (c) { return Math.round(c * amount + 255 * (1 - amount)); };
    return 'rgb(' + mix(r) + ',' + mix(g) + ',' + mix(b) + ')';
  }
  function paintSwatches() {
    document.querySelectorAll('.ss-pdp__sw').forEach(function (sw) {
      var name = sw.getAttribute('data-color-value') || sw.getAttribute('aria-label') || '';
      var hex = colorFor(name);
      if (hex) {
        var dot = sw.querySelector('.ss-pdp__sw-dot');
        if (dot) {
          dot.style.setProperty('background-image', 'none', 'important');
          dot.style.setProperty('background-color', hex, 'important');
        }
        sw.style.setProperty('--sw-hex', hex);
        sw.style.setProperty('--sw-tip-bg', lightenHex(hex, 0.3));
        if (!isDark(hex)) sw.classList.add('ss-pdp__sw--light');
      }
      var tip = tipFor(name);
      var tipEl = sw.querySelector('.ss-pdp__sw-tip');
      if (tip && tipEl) tipEl.textContent = tip;
    });
    clampSwatchTips();
  }

  function clampSwatchTips() {
    var margin = 12;
    document.querySelectorAll('.ss-pdp__sw-tip').forEach(function (tip) {
      tip.style.setProperty('--tip-shift', '0px');
      var rect = tip.getBoundingClientRect();
      if (!rect.width) return;
      var shift = 0;
      if (rect.left < margin) {
        shift = margin - rect.left;
      } else if (rect.right > window.innerWidth - margin) {
        shift = (window.innerWidth - margin) - rect.right;
      }
      if (shift) tip.style.setProperty('--tip-shift', shift + 'px');
    });
  }

  function pruneGallery(data) {
    var stage = document.querySelector('[data-pdp-stage]');
    var thumbsWrap = document.querySelector('[data-pdp-thumbs]');
    if (!stage || !thumbsWrap) return [];
    var media = (data && (data.media || data.images)) || [];
    var slides = stage.querySelectorAll('.ss-pdp__slide');
    var thumbs = thumbsWrap.querySelectorAll('.ss-pdp__thumb');
    var heroIdx = 0;
    var infoIdxs = [];
    for (var i = 0; i < media.length && infoIdxs.length < (GALLERY_KEEP_COUNT - 1); i++) {
      var m = media[i];
      if (i === heroIdx) continue;
      var isVariant = !!(m && m.variant_ids && m.variant_ids.length > 0);
      if (!isVariant) infoIdxs.push(i);
    }
    while (infoIdxs.length < (GALLERY_KEEP_COUNT - 1)) {
      var fallback = infoIdxs.length + 1;
      if (fallback >= media.length) break;
      if (infoIdxs.indexOf(fallback) === -1 && fallback !== heroIdx) infoIdxs.push(fallback);
    }
    var keepSet = {};
    keepSet[heroIdx] = true;
    infoIdxs.forEach(function (n) { keepSet[n] = true; });
    for (var s = 0; s < slides.length; s++) {
      if (!keepSet[s]) {
        slides[s].style.display = 'none';
        slides[s].setAttribute('aria-hidden', 'true');
        var simg = slides[s].querySelector('img');
        if (simg) { simg.removeAttribute('src'); simg.removeAttribute('srcset'); }
      }
    }
    for (var t = 0; t < thumbs.length; t++) {
      if (!keepSet[t]) {
        thumbs[t].style.display = 'none';
        thumbs[t].setAttribute('aria-hidden', 'true');
        thumbs[t].setAttribute('tabindex', '-1');
        var timg = thumbs[t].querySelector('img');
        if (timg) { timg.removeAttribute('src'); timg.removeAttribute('srcset'); }
      } else {
        thumbs[t].dataset.ssKeep = '1';
      }
    }
    slides.forEach(function (sl, idx) { sl.classList.remove('is-active'); if (idx === heroIdx) sl.classList.add('is-active'); });
    thumbs.forEach(function (th, idx) { th.classList.remove('is-active'); if (idx === heroIdx) th.classList.add('is-active'); });
    return [heroIdx].concat(infoIdxs);
  }

  function getProductData() {
    if (window.__ssProductCache) return Promise.resolve(window.__ssProductCache);
    var pdp = document.querySelector('[data-ss-pdp]');
    var handle = pdp && pdp.getAttribute('data-product-handle');
    if (!handle) return Promise.reject(new Error('no handle'));
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) { window.__ssProductCache = data; return data; });
  }
  function valueFromButton(btn) {
    return btn.getAttribute('data-color-value')
        || btn.getAttribute('data-size-value')
        || btn.getAttribute('data-generic-value')
        || (btn.textContent || '').trim();
  }
  function selectedOptionValues() {
    var picks = {};
    document.querySelectorAll('.ss-pdp__sw.is-active, .ss-pdp__size.is-active').forEach(function (el) {
      var pos = parseInt(el.getAttribute('data-option-position'), 10);
      if (!pos) return;
      var val = valueFromButton(el);
      if (val) picks[pos] = val;
    });
    return picks;
  }
  function findVariantByPicks(data, picks) {
    if (!data || !data.variants) return null;
    var positions = Object.keys(picks);
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var ok = true;
      for (var k = 0; k < positions.length; k++) {
        var idx = parseInt(positions[k], 10) - 1;
        if (v.options[idx] !== picks[positions[k]]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function shopifyImageBase(url) {
    var m = (url || '').match(/\/([^/?#]+?)(?:_\d+x[\d]*)?\.(?:jpg|jpeg|png|webp|gif)(?:[?#]|$)/i);
    return m ? m[1].toLowerCase() : '';
  }
  function setHeroImage(variant) {
    if (!variant || !variant.featured_image) return;
    var fi = variant.featured_image;
    var src = fi.src || '';
    if (!src) return;
    var slides = document.querySelectorAll('.ss-pdp__slide');
    var thumbs = document.querySelectorAll('.ss-pdp__thumb');
    if (!slides.length) return;
    var hero = slides[GALLERY_HERO_INDEX];
    if (!hero) return;
    var img = hero.querySelector('img');
    if (img) {
      var bigSrc = src.replace(/_(\d+)x(\d*)\./, '_1200x.');
      if (bigSrc === src && /\.(jpg|jpeg|png|webp)(\?|$)/i.test(src)) {
        bigSrc = src.replace(/\.(jpg|jpeg|png|webp)(\?|$)/i, '_1200x.$1$2');
      }
      if (shopifyImageBase(img.src) !== shopifyImageBase(bigSrc)) {
        img.src = bigSrc;
        img.removeAttribute('srcset');
        img.alt = variant.title || '';
      }
    }
    var thumb = thumbs[GALLERY_HERO_INDEX];
    if (thumb) {
      var timg = thumb.querySelector('img');
      if (timg) {
        var smallSrc = src.replace(/_(\d+)x(\d*)\./, '_200x.');
        if (smallSrc === src && /\.(jpg|jpeg|png|webp)(\?|$)/i.test(src)) {
          smallSrc = src.replace(/\.(jpg|jpeg|png|webp)(\?|$)/i, '_200x.$1$2');
        }
        if (shopifyImageBase(timg.src) !== shopifyImageBase(smallSrc)) {
          timg.src = smallSrc;
          timg.removeAttribute('srcset');
        }
      }
    }
    slides.forEach(function (s) { s.classList.remove('is-active'); });
    hero.classList.add('is-active');
    thumbs.forEach(function (th) { th.classList.remove('is-active'); });
    if (thumb) thumb.classList.add('is-active');
  }

  function fmtMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  /* Gate the add-to-cart + sticky buttons on availability so sold-out /
     non-existent variants can't be silently added. */
  function setBuyAvailability(available, opts) {
    opts = opts || {};
    var label = opts.soldOutLabel || 'Sold out';
    var addBtn = document.querySelector('[data-pdp-add]');
    var stickyBtn = document.querySelector('[data-pdp-sticky-add]');
    [addBtn, stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !available;
      btn.classList.toggle('is-soldout', !available);
      btn.setAttribute('aria-disabled', String(!available));
    });
    if (addBtn) {
      var addText = addBtn.querySelector('.ss-pdp__add-text');
      if (addText) {
        if (!available) {
          if (!addText.dataset.ssDefault) addText.dataset.ssDefault = addText.innerHTML;
          addText.textContent = label;
        } else if (addText.dataset.ssDefault) {
          addText.innerHTML = addText.dataset.ssDefault;
          delete addText.dataset.ssDefault;
        }
      }
    }
    if (stickyBtn) {
      if (!available) {
        if (!stickyBtn.dataset.ssDefault) stickyBtn.dataset.ssDefault = stickyBtn.textContent;
        stickyBtn.textContent = label;
      } else if (stickyBtn.dataset.ssDefault) {
        stickyBtn.textContent = stickyBtn.dataset.ssDefault;
        delete stickyBtn.dataset.ssDefault;
      }
    }
  }

  /* Respect inventory limits on the quantity input. */
  function applyQtyMax(variant) {
    var qty = document.querySelector('[data-qty-input]');
    if (!qty) return;
    var tracked = variant && variant.inventory_management && variant.inventory_policy !== 'continue';
    var max = (tracked && typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : null;
    if (max != null && max >= 0) {
      qty.max = max;
      var cur = parseInt(qty.value, 10) || 1;
      if (max === 0) qty.value = '0';
      else if (cur > max) qty.value = String(max);
    } else {
      qty.removeAttribute('max');
    }
  }

  /* Rebuild the price block from scratch so compare-at / "Save" never go stale
     when switching between a discounted and a full-price variant. */
  function renderPrice(variant) {
    var priceWrap = document.querySelector('[data-pdp-price]');
    if (!priceWrap) return;
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (onSale) {
      priceWrap.innerHTML =
        '<span class="ss-pdp__price-sale">' + fmtMoney(variant.price) + '</span>' +
        '<span class="ss-pdp__price-compare">' + fmtMoney(variant.compare_at_price) + '</span>' +
        '<span class="ss-pdp__price-save">' + Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) + '% OFF</span>';
    } else {
      priceWrap.innerHTML = '<span class="ss-pdp__price-current">' + fmtMoney(variant.price) + '</span>';
    }
  }

  function updatePriceAndForm(variant) {
    if (!variant) return;
    var hidden = document.querySelector('[data-pdp-variant-id]');
    if (hidden) hidden.value = variant.id;
    try { history.replaceState({}, '', '?variant=' + variant.id); } catch (e) {}
    setBuyAvailability(variant.available !== false);
    renderPrice(variant);
    var stickyPrice = document.querySelector('[data-pdp-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = fmtMoney(variant.price);
    applyQtyMax(variant);
  }
  /* Re-derive which Size buttons are in stock for the currently selected
     color/pack combo and hide the rest, so the size list stays correct as
     other options change instead of being stuck with the page-load state. */
  function variantInStock(variant) {
    if (!variant) return false;
    if (!variant.inventory_management) return true;
    return variant.inventory_quantity > 0;
  }
  function updateSizeAvailability(data) {
    var sizeBtns = document.querySelectorAll('.ss-pdp__size[data-size-value]');
    if (!sizeBtns.length || !data) return;
    var sizePos = sizeBtns[0].getAttribute('data-option-position');
    var basePicks = selectedOptionValues();
    var firstAvailableBtn = null;
    var activeStillAvailable = false;
    sizeBtns.forEach(function (btn) {
      var picks = {};
      Object.keys(basePicks).forEach(function (pos) { picks[pos] = basePicks[pos]; });
      picks[sizePos] = valueFromButton(btn);
      var variant = findVariantByPicks(data, picks);
      var inStock = variantInStock(variant);
      var li = btn.closest('li');
      if (li) li.hidden = !inStock;
      if (inStock && !firstAvailableBtn) firstAvailableBtn = btn;
      if (inStock && btn.classList.contains('is-active')) activeStillAvailable = true;
    });
    if (!activeStillAvailable && firstAvailableBtn) {
      sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
      firstAvailableBtn.classList.add('is-active');
    }
  }
  function resolveAndApply() {
    return getProductData().then(function (data) {
      updateSizeAvailability(data);
      var picks = selectedOptionValues();
      var variant = findVariantByPicks(data, picks);
      if (!variant) { setBuyAvailability(false, { soldOutLabel: 'Unavailable' }); return null; }
      updatePriceAndForm(variant);
      setHeroImage(variant);
      return variant;
    }).catch(function () { return null; });
  }

  /* Wire the previously-dead sticky add button to submit the buy form,
     and reveal the sticky bar once the main add button scrolls off screen. */
  function wireStickyAdd() {
    if (window.__ssStickyBound) return;
    window.__ssStickyBound = true;
    var stickyBtn = document.querySelector('[data-pdp-sticky-add]');
    var form = document.querySelector('[data-pdp-form]');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
    var bar = document.querySelector('[data-pdp-sticky]');
    var addBtn = document.querySelector('[data-pdp-add]');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      });
      io.observe(addBtn);
    }
  }
  function onOptionClick(btn) {
    var group = btn.closest('.ss-pdp__swatches, .ss-pdp__sizes');
    if (group) {
      group.querySelectorAll('.is-active').forEach(function (el) { el.classList.remove('is-active'); });
      btn.classList.add('is-active');
    }
    if (btn.classList.contains('ss-pdp__sw')) {
      var label = document.querySelector('.ss-pdp__option-head [data-color-value]');
      if (label) label.textContent = btn.getAttribute('data-color-value') || '';
      setTimeout(paintSwatches, 30);
    }
    resolveAndApply();
  }
  function wireOptionClicks() {
    if (window.__ssOptionBound) return;
    window.__ssOptionBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.ss-pdp__sw, .ss-pdp__size');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      onOptionClick(btn);
    }, true);
  }
  function wireThumbClicks() {
    if (window.__ssThumbBound) return;
    window.__ssThumbBound = true;
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('.ss-pdp__thumb');
      if (!t || t.style.display === 'none') return;
      var idx = parseInt(t.getAttribute('data-thumb-index'), 10);
      if (isNaN(idx)) return;
      var slides = document.querySelectorAll('.ss-pdp__slide');
      var thumbs = document.querySelectorAll('.ss-pdp__thumb');
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      thumbs.forEach(function (th) { th.classList.remove('is-active'); });
      if (slides[idx]) slides[idx].classList.add('is-active');
      if (thumbs[idx]) thumbs[idx].classList.add('is-active');
      if (window.innerWidth <= 990) {
        var stage = document.querySelector('[data-pdp-stage]');
        if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }, true);
  }
  function wireGalleryNav() {
    if (window.__ssGalleryNavBound) return;
    window.__ssGalleryNavBound = true;
    document.addEventListener('click', function (e) {
      var prev = e.target.closest && e.target.closest('[data-pdp-prev]');
      var next = e.target.closest && e.target.closest('[data-pdp-next]');
      if (!prev && !next) return;
      var slides = document.querySelectorAll('.ss-pdp__slide');
      var thumbs = document.querySelectorAll('.ss-pdp__thumb');
      var visibleIdxs = [];
      thumbs.forEach(function (th, i) { if (th.dataset.ssKeep === '1') visibleIdxs.push(i); });
      if (!visibleIdxs.length) return;
      var activeIdx = -1;
      for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) { activeIdx = i; break; }
      var pos = visibleIdxs.indexOf(activeIdx);
      var nextIdx;
      if (pos === -1) nextIdx = visibleIdxs[0];
      else if (prev) nextIdx = visibleIdxs[(pos - 1 + visibleIdxs.length) % visibleIdxs.length];
      else nextIdx = visibleIdxs[(pos + 1) % visibleIdxs.length];
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      thumbs.forEach(function (th) { th.classList.remove('is-active'); });
      if (slides[nextIdx]) slides[nextIdx].classList.add('is-active');
      if (thumbs[nextIdx]) thumbs[nextIdx].classList.add('is-active');
    }, true);
  }

  /* Mirror the Liquid pattern in ss-use-case.liquid ~line 38:
       assign _cdn = 'x' | asset_url | split: '/t/' | first
       assign _src = _cdn | append: '/files/' | append: filename
     If name is already a full URL (contains '://'), it is returned unchanged. */
  function getCDNBase() {
    var candidates = [
      document.querySelector('link[rel="stylesheet"][href*="/t/"]'),
      document.querySelector('script[src*="/t/"]'),
      document.querySelector('img[src*="/t/"]')
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el) continue;
      var url = el.href || el.src;
      if (url) return url.split('/t/')[0];
    }
    return '';
  }
  function shopifyFileUrl(name) {
    if (!name || name.indexOf('://') !== -1) return name;
    var base = getCDNBase();
    return base ? (base + '/files/' + name) : name;
  }

  function makeImg(src, alt, cls) {
    var img = document.createElement('img');
    img.src = shopifyFileUrl(src); img.alt = alt || ''; img.loading = 'lazy'; img.decoding = 'async'; img.className = cls;
    return img;
  }
  function enhanceBenefits() {
    if (!cfg) return;
    var img = cfg.img;
    document.querySelectorAll('.ss-pc__benefits .ss-pc__benefit-card').forEach(function (card, i) {
      if (card.querySelector('.ss-pc__benefit-photo')) return;
      if (!img.benefit[i]) return;
      card.insertBefore(makeImg(img.benefit[i], img.benefitAlt[i], 'ss-pc__benefit-photo'), card.firstChild);
    });
  }
  function enhanceSteps() {
    if (!cfg) return;
    var img = cfg.img;
    document.querySelectorAll('.ss-pc__howto .ss-pc__step').forEach(function (step, i) {
      if (step.querySelector('.ss-pc__step-photo')) return;
      if (!img.step[i]) return;
      step.insertBefore(makeImg(img.step[i], img.stepAlt[i], 'ss-pc__step-photo'), step.firstChild);
    });
  }

  /* ============================================================
     PRESS / FEATURED IN — interactive tab carousel
     ============================================================ */
  function enhancePress() {
    if (!cfg) return;
    var PRESS_TABS = cfg.pressTabs;
    var press = document.querySelector('.ss-pc__press');
    if (!press || press.dataset.ssEnhanced === '1') return;
    if (!PRESS_TABS || !PRESS_TABS.length) return;

    function buildPress() {
      if (press.dataset.ssEnhanced === '1') return;

      // Build logo tab list
      var tabsHTML = PRESS_TABS.map(function (t, i) {
        return (
          '<li class="ss-pc__plogo ' + t.cls + (i === 0 ? ' is-active' : '') + '" data-tab="' + i + '" role="tab" aria-selected="' + (i === 0 ? 'true' : 'false') + '" tabindex="' + (i === 0 ? '0' : '-1') + '"><span>' + t.name + '</span></li>'
        );
      }).join('');

      var first = PRESS_TABS[0];
      press.innerHTML =
        '<p class="ss-eyebrow ss-pc__eyebrow">FEATURED IN</p>' +
        '<ul class="ss-pc__press-logos" role="tablist">' + tabsHTML + '</ul>' +
        '<div class="ss-pc__press-card" data-press-card>' +
          '<figure class="ss-pc__press-figure">' +
            '<img class="ss-pc__press-img" src="' + shopifyFileUrl(first.image) + '" alt="' + first.alt + '" loading="lazy" decoding="async">' +
          '</figure>' +
          '<blockquote class="ss-pc__press-quote">' +
            '<span class="ss-pc__press-mark" aria-hidden="true">"</span>' +
            '<p class="ss-pc__press-quote-text">' + first.quote + '</p>' +
            '<footer class="ss-pc__press-cite">— <span class="ss-pc__press-cite-name">' + first.name.toUpperCase() + '</span></footer>' +
            '<div class="ss-pc__press-dots" role="tablist">' +
              PRESS_TABS.map(function (_, i) { return '<button type="button" class="ss-pc__press-dot' + (i === 0 ? ' is-active' : '') + '" data-tab="' + i + '" aria-label="Quote ' + (i + 1) + '"></button>'; }).join('') +
            '</div>' +
          '</blockquote>' +
        '</div>';
      press.dataset.ssEnhanced = '1';

      var activeIdx = 0;
      var autoplayId = null;
      var paused = false;

      function setTab(idx, fromUser) {
        idx = ((idx % PRESS_TABS.length) + PRESS_TABS.length) % PRESS_TABS.length;
        if (idx === activeIdx) return;
        var t = PRESS_TABS[idx];

        var img = press.querySelector('.ss-pc__press-img');
        var quote = press.querySelector('.ss-pc__press-quote-text');
        var cite = press.querySelector('.ss-pc__press-cite-name');
        var card = press.querySelector('[data-press-card]');

        // Crossfade card content
        if (card) card.classList.add('is-changing');
        setTimeout(function () {
          if (img) { img.src = shopifyFileUrl(t.image); img.alt = t.alt; }
          if (quote) quote.textContent = t.quote;
          if (cite) cite.textContent = t.name.toUpperCase();
          if (card) card.classList.remove('is-changing');
        }, 180);

        // Active state on logos and dots
        press.querySelectorAll('.ss-pc__plogo').forEach(function (el, i) {
          el.classList.toggle('is-active', i === idx);
          el.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          el.setAttribute('tabindex', i === idx ? '0' : '-1');
        });
        press.querySelectorAll('.ss-pc__press-dot').forEach(function (el, i) {
          el.classList.toggle('is-active', i === idx);
        });
        activeIdx = idx;
        if (fromUser) restartAutoplay();
      }

      function nextTab() { setTab(activeIdx + 1, false); }
      function startAutoplay() {
        stopAutoplay();
        autoplayId = setInterval(function () { if (!paused) nextTab(); }, 6000);
      }
      function stopAutoplay() { if (autoplayId) { clearInterval(autoplayId); autoplayId = null; } }
      function restartAutoplay() { stopAutoplay(); startAutoplay(); }

      // Tab clicks
      press.querySelectorAll('.ss-pc__plogo, .ss-pc__press-dot').forEach(function (el) {
        el.addEventListener('click', function () {
          var i = parseInt(el.getAttribute('data-tab'), 10);
          if (!isNaN(i)) setTab(i, true);
        });
      });
      // Keyboard nav on logos
      press.querySelector('.ss-pc__press-logos').addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var dir = e.key === 'ArrowLeft' ? -1 : 1;
        setTab(activeIdx + dir, true);
        var active = press.querySelector('.ss-pc__plogo.is-active');
        if (active) active.focus();
      });
      // Pause autoplay on hover
      press.addEventListener('mouseenter', function () { paused = true; });
      press.addEventListener('mouseleave', function () { paused = false; });
      // Pause when off-screen
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { paused = !e.isIntersecting ? true : paused; });
        });
        io.observe(press);
      }
      startAutoplay();
    }

    buildPress();
  }

  function enhanceVideo() {
    var wrap = document.querySelector('.ss-pc__video-block .ss-pc__video-wrap');
    if (!wrap || wrap.dataset.ssEnhanced === '1') return;
    var video = wrap.querySelector('video.ss-pc__video');
    if (!video) return;
    if (!wrap.querySelector('.ss-pc__ss-scrim')) {
      var scrim = document.createElement('div');
      scrim.className = 'ss-pc__ss-scrim';
      if (video.nextSibling) wrap.insertBefore(scrim, video.nextSibling); else wrap.appendChild(scrim);
    }
    if (!wrap.querySelector('.ss-pc__video-play')) {
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'ss-pc__video-play';
      btn.setAttribute('aria-label', 'Play full video');
      btn.innerHTML = '<span class="ss-pc__video-play-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg></span><span>Watch the video</span>';
      btn.addEventListener('click', function () { openModal(video.currentSrc || video.src); });
      wrap.appendChild(btn);
    }
    wrap.dataset.ssEnhanced = '1';
  }
  function ensureModal() {
    var m = document.querySelector('.ss-pc__video-modal');
    if (m) return m;
    m = document.createElement('div');
    m.className = 'ss-pc__video-modal';
    m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Product video');
    m.innerHTML = '<div class="ss-pc__video-modal__inner"><button type="button" class="ss-pc__video-modal__close" aria-label="Close">×</button><video class="ss-pc__video-modal__video" controls playsinline preload="metadata"></video></div>';
    document.body.appendChild(m);
    var closeBtn = m.querySelector('.ss-pc__video-modal__close');
    var modalVideo = m.querySelector('.ss-pc__video-modal__video');
    function close() {
      m.removeAttribute('data-open');
      try { modalVideo.pause(); } catch (e) {}
      modalVideo.removeAttribute('src'); modalVideo.load();
      document.body.style.overflow = '';
    }
    closeBtn.addEventListener('click', close);
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.getAttribute('data-open') === '1') close(); });
    return m;
  }
  function openModal(src) {
    if (!src) return;
    var m = ensureModal();
    var v = m.querySelector('.ss-pc__video-modal__video');
    v.src = src; v.currentTime = 0;
    m.setAttribute('data-open', '1');
    document.body.style.overflow = 'hidden';
    var p = v.play(); if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  var BF_ICONS = {
    foot:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 3c2 0 3 1.4 3 3.5S11 10 9 10 6 8.6 6 6.5 7 3 9 3zM13 5c1.4 0 2.2.9 2.2 2.2S14.4 9.4 13 9.4 10.8 8.5 10.8 7.2 11.6 5 13 5zM16 7c1.1 0 1.8.7 1.8 1.8S17.1 10.6 16 10.6 14.2 9.9 14.2 8.8 14.9 7 16 7zM18 10c.9 0 1.5.6 1.5 1.5S18.9 13 18 13s-1.5-.6-1.5-1.5S17.1 10 18 10zM7 12c0 3 2 6 6 6 1.7 0 3-.5 4-1.5 1 1 .6 3.5-2 4.5-3 1-7 .5-9-2-1.6-2-1-5 1-7z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
    heel:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 14c1-5 5-9 11-9 4 0 6 3 5 7l-2 6c-.5 2-2 3-4 3H7c-2 0-3-1-3-3v-4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    standing:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="4.5" r="2" stroke="currentColor" stroke-width="1.6"/><path d="M12 7v8m-4 6l4-6 4 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    ankle:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 3v10c0 2 1 3 3 3s3-1 3-3V3M7 17c1 2 3 3 5 3s4-1 5-3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    swell:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3c4 5 6 8 6 11a6 6 0 11-12 0c0-3 2-6 6-11z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    boot:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 3h3v10h4c2 0 3 1 3 3v3c0 1-1 2-2 2H7c-2 0-3-1-3-3v-3c0-2 1-3 3-3h2V3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    knee:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="2.5" stroke="currentColor" stroke-width="1.6"/></svg>',
    stairs:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 21h4v-4h4v-4h4v-4h4V5h4" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>',
    tendon:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M4 12c4 0 4-6 8-6s4 12 8 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    jump:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="14" cy="5" r="2" stroke="currentColor" stroke-width="1.6"/></svg>',
    bike:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="6" cy="17" r="3.5" stroke="currentColor" stroke-width="1.6"/><circle cx="18" cy="17" r="3.5" stroke="currentColor" stroke-width="1.6"/></svg>',
    joint:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.6"/></svg>',
    surgery:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3" y="9" width="18" height="6" rx="2" transform="rotate(-30 12 12)" stroke="currentColor" stroke-width="1.6"/></svg>',
    walk:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="13" cy="4" r="2" stroke="currentColor" stroke-width="1.6"/></svg>',
    snow:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 2v20M2 12h20M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    tennis:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/></svg>',
    golf:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 4v12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    lift:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M2 12h2M20 12h2M5 6v12M19 6v12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    desk:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3" y="6" width="18" height="11" rx="1.5" stroke="currentColor" stroke-width="1.6"/></svg>',
    recover:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M21 12.8A9 9 0 1112 3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    wrist:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 3v6h-3v6h3v6M15 3v6h3v6h-3v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    type:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="3" y="7" width="18" height="10" rx="2" stroke="currentColor" stroke-width="1.6"/></svg>',
    sleep:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M20 14a8 8 0 11-10-10 6 6 0 0010 10z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    clock:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/></svg>',
    sport:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/></svg>',
    sore:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/></svg>',
    spark:'<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3v18M3 12h18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
  };
  function bfFileHtml(filename) {
    return '<img src="' + shopifyFileUrl(filename) + '" alt="" class="ss-pc__bf-ico-img" aria-hidden="true" loading="lazy" width="46" height="46" style="overflow:hidden;">';
  }
  function isFilename(s) {
    var ext = s.split('.').pop().toLowerCase();
    return ext === 'svg' || ext === 'png' || ext === 'jpg' || ext === 'jpeg' || ext === 'gif' || ext === 'webp';
  }
  function getBfIconHtml(icon) {
    if (!icon) return BF_ICONS.spark;
    if (icon.indexOf('://') !== -1 || isFilename(icon)) return bfFileHtml(icon);
    var val = BF_ICONS[icon];
    if (val) {
      if (val.charAt(0) === '<') return val;
      if (isFilename(val)) return bfFileHtml(val);
    }
    return BF_ICONS.spark;
  }
  function enhanceBestFor() {
    var section = document.querySelector('.ss-pc__bestfor');
    if (!section || section.dataset.ssBfEnhanced === '1') return;
    if (!cfg || !cfg.bestFor || !cfg.bestFor.length) return;
    var ul = section.querySelector('.ss-pc__chips');
    if (!ul) return;
    var cards = cfg.bestFor.map(function (item) {
      return '<li class="ss-pc__bf-card"><span class="ss-pc__bf-ico" aria-hidden="true">' + getBfIconHtml(item.icon) + '</span><div class="ss-pc__bf-text"><p class="ss-pc__bf-title">' + item.title + '</p>' + (item.sub ? '<p class="ss-pc__bf-sub">' + item.sub + '</p>' : '') + '</div><span class="ss-pc__bf-arrow" aria-hidden="true"></span></li>';
    }).join('');
    var h2 = section.querySelector('.ss-h2');
    if (h2 && !section.querySelector('.ss-pc__bf-intro')) {
      var intro = document.createElement('p');
      intro.className = 'ss-body ss-pc__bf-intro';
      intro.textContent = 'Tested on real bodies through the most common day-to-day strains.';
      h2.insertAdjacentElement('afterend', intro);
    }
    var grid = document.createElement('ul');
    grid.className = 'ss-pc__bf-grid';
    grid.setAttribute('role', 'list');
    grid.innerHTML = cards;

    function insert() {
      ul.replaceWith(grid);
      section.dataset.ssBfEnhanced = '1';
    }

    insert();
  }

  /* Per-product compare rows. Icon filenames are resolved via shopifyFileUrl()
     so they load from /files/ on whichever store the theme is installed on,
     as long as the PNG is uploaded to that store's Files. */
  var PRODUCT_COMPARE = {
    'ankle-brace': {
      img: 'AB_Header.png',
      imgPos: { bottom: '32%', left: '-2%' },
      imgMobilePos: { bottom: '32%', left: '-22%' },
      rows: [
        // { ico: '', title: '', ours: '', theirs: '' },
        { ico: 'Slim_under_sneakers_WT_AB.png', title: 'Slim under sleeves', ours: 'yes', theirs: 'no' },
        { ico: 'Adjustable_Wrap_Fit_WT_AB.png', title: 'Adjustable wrap fit', ours: 'yes', theirs: 'no' },
        { ico: 'Soft_knit_comfort_WT_AB.png', title: 'Soft knit comfort', ours: 'yes', theirs: 'yes' },
        { ico: 'All-day_wear_WT_AB.png', title: 'All-day wear', ours: 'yes', theirs: 'no' },
        { ico: 'Cute_color_options_WT_AB.png', title: 'Cute color options', ours: 'yes', theirs: 'no' },
        { ico: 'Moves_with_you_WT_AB.png', title: 'Moves with you', ours: 'yes', theirs: 'no' }
      ]
    },
    'elbow-brace': {
      img: 'EB_Header.png',
      imgPos: { bottom: '5%', left: '-2%' },
      imgMobilePos: { bottom: '-13%', left: '-35%' },
      rows: [
        { ico: 'Slim_under_sleeves_WT_EB.png',        title: 'Slim under sleeve',         ours: 'yes', theirs: 'no' },
        { ico: 'Adjustable_wrap_fit_WT_EB.png', title: 'Adjustable wrap fit',     ours: 'yes', theirs: 'no' },
        { ico: 'Moisture-wicking_fabric_WT_EB.png',   title: 'Moisture-wicking fabric',      ours: 'yes', theirs: 'yes' },
        { ico: 'targeted_compression_WT_EB.png',   title: 'Targeted compression',         ours: 'yes', theirs: 'no' },
        { ico: '3_strap_lengths_WT_EB.png',    title: '3 Strap length',          ours: 'yes', theirs: 'no' },
        // { ico: 'compare-icon-motion.png',      title: 'Full range of motion',      ours: 'yes', theirs: 'no' },
        { ico: 'Moves_with_you_WT_EB.png',        title: 'Moves with you',    ours: 'yes', theirs: 'no' }
      ]
    },
    'elbow-sleeve': {
      img: 'ES_Header.png',
      imgPos: { bottom: '32%', left: '-2%' },
      imgMobilePos: { bottom: '28%', left: '-28%' },
      rows: [
        { ico: 'Slim_under_sleeves_WT_ES.png', title: 'Slim under sleeves', ours: 'yes', theirs: 'no' },
        { ico: 'Graduated_compression_WT_ES.png', title: 'Graduated Compression', ours: 'yes', theirs: 'yes' },
        { ico: 'Breathable_Knit_WT_ES.png', title: 'Breathable knit', ours: 'yes', theirs: 'yes' },
        { ico: 'All_Day_Comfort_WT_ES.png', title: 'All-Day Comfort', ours: 'yes', theirs: 'no' },
        { ico: 'Cute_color_options_WT_AB.png', title: '9 Color Options', ours: 'yes', theirs: 'no' },
        { ico: 'Moves_with_you_WT_ES.png', title: 'Moves with you', ours: 'yes', theirs: 'no' },
        // { ico: 'compare-icon-grip.png',        title: 'No-slip grip lining',       ours: 'yes', theirs: 'no' }
      ]
    },
    'patella-strap': {
      img: 'PS_Header.png',
      imgPos: { bottom: '5%', left: '-2%' },
      imgMobilePos: { bottom: '-13%', left: '-35%' },
      rows: [
        { ico: 'Slim_under_sleeves_WT_PS.png', title: 'Slim under pants', ours: 'yes', theirs: 'yes' },
        { ico: 'Adjustable_wrap_fit_WT_PS.png', title: 'Adjustable wrap fit', ours: 'yes', theirs: 'no' },
        { ico: 'Moisture-wicking_fabric_WT_PS.png', title: 'Moisture-wicking fabric', ours: 'yes', theirs: 'maybe' },
        { ico: 'Targeted_compression_WT_PS.png', title: 'Targeted compression', ours: 'yes', theirs: 'no' },
        { ico: '3_strap_lengths_WT_PS.png', title: '3 strap lengths', ours: 'yes', theirs: 'no' },
        { ico: 'Moves_with_you_WT_PS.png', title: 'Moves with you', ours: 'yes', theirs: 'no' }
      ]
    },
    'knee-brace': {
      img: 'KS_Header.png',
      imgPos: { bottom: '32%', left: '-2%' },
      imgMobilePos: { bottom: '31%', left: '-10%' },
      rows: [
        { ico: 'Open_-_Patella_Design_WT_KB.png', title: 'Open-Patella Design', ours: 'yes', theirs: 'no' },
        { ico: 'Adjustable_Straps_WT_KB.png', title: 'Adjustable Straps', ours: 'yes', theirs: 'no' },
        { ico: 'Non-slip_Grip_WT_KB.png', title: 'Non-Slip Grip', ours: 'yes', theirs: 'yes' },
        { ico: 'Targeted_Support_WT_KB.png', title: 'Targeted Support', ours: 'yes', theirs: 'no' },
        { ico: 'Breathable_Material_WT_KB.png', title: 'Breathable Material', ours: 'yes', theirs: 'yes' },
        { ico: 'Moves_with_you_WT_KB.png', title: 'Moves with you', ours: 'yes', theirs: 'no' },
      ]
    }
  };
  var CHECK = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4 10-10" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CROSS = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/></svg>';
  var SPARK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M12 1 L13.8 10.2 L23 12 L13.8 13.8 L12 23 L10.2 13.8 L1 12 L10.2 10.2 Z"/></svg>';
  function rebuildCompare() {
    var compare = document.querySelector('.ss-pc__compare');
    if (!compare || compare.dataset.ssRebuilt === '1') return;
    var head = compare.querySelector('.ss-pc__head');
    if (head) {
      var h2 = head.querySelector('.ss-h2');
      var sub = head.querySelector('.ss-pc__sub');
      if (h2) h2.innerHTML = '<span class="ss-pc__cv-spark" aria-hidden="true">' + SPARK + '</span> Why <span class="ss-pc__cv-accent">Sleeve Stars</span> win <span class="ss-pc__cv-spark" aria-hidden="true">' + SPARK + '</span>';
      if (sub) sub.textContent = 'Medical-grade compression vs. the drugstore brace.';
    }
    var oldTable = compare.querySelector('.ss-pc__compare-table'); if (oldTable) oldTable.remove();
    var oldV2 = compare.querySelector('.ss-pc__compare-v2'); if (oldV2) oldV2.remove();
    var oldV3 = compare.querySelector('.ss-pc__compare-v3'); if (oldV3) oldV3.remove();
    var oldV4 = compare.querySelector('.ss-pc__compare-v4'); if (oldV4) oldV4.remove();
    var productEntry = (cfgKey && PRODUCT_COMPARE[cfgKey]) || {};
    var rows = productEntry.rows || [];
    if (!rows.length) { compare.dataset.ssRebuilt = '1'; return; }
    rows = rows.map(function (r) {
      var title = ((r && r.title) || '').trim();
      return {
        ico: r && r.ico,
        title: title,
        ours: r && r.ours,
        theirs: r && r.theirs,
        isSpacer: title.length === 0
      };
    });
    var compareRows = rows.filter(function (r) { return !r.isSpacer; });
    var headerImgFile = productEntry.img || '';
    var productImgHtml = '';
    if (headerImgFile) {
      var imgStyleProps = [];
      var imgPos = productEntry.imgPos || {};
      var imgMobilePos = productEntry.imgMobilePos || {};
      if (imgPos.bottom) imgStyleProps.push('--img-bottom:' + imgPos.bottom);
      if (imgPos.left) imgStyleProps.push('--img-left:' + imgPos.left);
      if (imgPos.transform) imgStyleProps.push('--img-transform:' + imgPos.transform);
      if (imgMobilePos.bottom) imgStyleProps.push('--img-m-bottom:' + imgMobilePos.bottom);
      if (imgMobilePos.left) imgStyleProps.push('--img-m-left:' + imgMobilePos.left);
      if (imgMobilePos.transform) imgStyleProps.push('--img-m-transform:' + imgMobilePos.transform);
      var imgStyleAttr = imgStyleProps.length ? ' style="' + imgStyleProps.join(';') + '"' : '';
      productImgHtml = '<img class="ss-pc__cmpx-head-img" width="120" height="120"' + imgStyleAttr + ' src="' + shopifyFileUrl(headerImgFile) + '" alt="" aria-hidden="true">';
    }
    var gridCells = '<div class="ss-pc__cmpx-cell ss-pc__cmpx-cell--head ss-pc__cmpx-cell--head-attr" aria-hidden="true"></div>'
      + '<div class="ss-pc__cmpx-cell ss-pc__cmpx-cell--head ss-pc__cmpx-cell--head-ours">' + productImgHtml + '<span>SLEEVE STARS</span></div>'
      + '<div class="ss-pc__cmpx-cell ss-pc__cmpx-cell--head ss-pc__cmpx-cell--head-theirs"><span>Others</span></div>'
      + compareRows.map(function (r) {
        var icoExt = r.ico ? r.ico.split('.').pop().toLowerCase() : '';
        var icoClass = 'ss-pc__cmpx-ico-img' + (icoExt === 'svg' ? ' ss-pc__cmpx-ico-img--svg' : ' ss-pc__cmpx-ico-img--png');
        var icoHtml = r.ico ? '<img src="' + shopifyFileUrl(r.ico) + '" alt="" class="' + icoClass + '" aria-hidden="true" loading="lazy">' : '';
        var theirsMark;
        if (r.theirs === 'yes') theirsMark = '<span class="ss-pc__cmpx-mark ss-pc__cmpx-mark--yes" aria-label="Yes">' + CHECK + '</span>';
        else if (r.theirs === 'maybe') theirsMark = '<span class="ss-pc__cmpx-mark ss-pc__cmpx-mark--maybe" aria-label="Maybe">?</span>';
        else theirsMark = '<span class="ss-pc__cmpx-mark ss-pc__cmpx-mark--no" aria-label="No">' + CROSS + '</span>';
        return ''
          + '<div class="ss-pc__cmpx-cell ss-pc__cmpx-cell--attr"><span class="ss-pc__cmpx-ico" aria-hidden="true">' + icoHtml + '</span><p class="ss-pc__cmpx-title">' + r.title + '</p></div>'
          + '<div class="ss-pc__cmpx-cell ss-pc__cmpx-cell--mark"><span class="ss-pc__cmpx-mark ss-pc__cmpx-mark--yes" aria-label="Yes">' + CHECK + '</span></div>'
          + '<div class="ss-pc__cmpx-cell ss-pc__cmpx-cell--mark">' + theirsMark + '</div>';
      }).join('');
    var v2 = document.createElement('div');
    v2.className = 'ss-pc__compare-v4';
    v2.innerHTML = '<div class="ss-pc__cmpx">' + gridCells + '</div>';
    compare.appendChild(v2);
    compare.dataset.ssRebuilt = '1';
  }

  function resolveConfig() {
    var pdp = document.querySelector('[data-ss-pdp]');
    var handle = ((pdp && pdp.getAttribute('data-product-handle')) || '').toLowerCase();
    cfg = null;
    cfgKey = null;
    for (var i = 0; i < PRODUCT_RULES.length; i++) {
      if (PRODUCT_RULES[i].test(handle)) { cfgKey = PRODUCT_RULES[i].key; cfg = PRODUCT_CONFIG[cfgKey] || null; break; }
    }
  }

  function whenCssReady(fn) {
    var link = document.querySelector('link[href*="sleevestars-pdp-visuals"][rel="stylesheet"]');
    if (!link || link.media === 'all') { fn(); } else { link.addEventListener('load', fn); }
  }

  function init() {
    try { resolveConfig(); } catch (e) {}
    try { paintSwatches(); } catch (e) {}
    try { wireOptionClicks(); } catch (e) {}
    try { wireThumbClicks(); } catch (e) {}
    try { wireGalleryNav(); } catch (e) {}
    try { wireStickyAdd(); } catch (e) {}
    getProductData().then(function (data) {
      try { pruneGallery(data); } catch (e) {}
      try { resolveAndApply(); } catch (e) {}
    }).catch(function () {});
    whenCssReady(function () {
      try { enhanceBenefits(); } catch (e) {}
      try { enhanceSteps(); } catch (e) {}
      try { enhancePress(); } catch (e) {}
      try { enhanceVideo(); } catch (e) {}
      try { rebuildCompare(); } catch (e) {}
      try { enhanceBestFor(); } catch (e) {}
    });
  }
  var tipResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(tipResizeTimer);
    tipResizeTimer = setTimeout(function () { try { clampSwatchTips(); } catch (e) {} }, 150);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
